import ApiService from "@/plugins/ApiService";
import { SET_STATION_INFO, SET_LISTENERS, SELECT_STATION, SET_LOADING, CLEAR_STATION_ID, SET_KEY } from "@/store/mutation-types";
import { FETCH_STATION_INFO, SERVER_ACTION } from "@/store/action-types";
import { saveStationId, getStationId, removeStationId } from "@/plugins/jwtService";
import _ from 'lodash'

const state = {
    station_info: {},
    selectedStation: {},
    stationId: getStationId()
}


const mutations = {

    [SET_STATION_INFO](state, data) {
        //console.log(data);

        if (data.message == undefined) {
            state.station_info = data
        } else {
            state.station_info = data.data
        }

    },

    [SELECT_STATION](state, station) {

        try {

            if (_.isEqual(state.selectedStation, station)) return
            state.selectedStation = station
            state.stationId = station.id
            saveStationId(station.id)
        } catch (error) {}

    },

    [CLEAR_STATION_ID](state) {
        state.stationId = null
        removeStationId()

    }

}


const actions = {

    [SERVER_ACTION]: async({ state, commit }, url) => {
        try {
            commit(SET_LOADING, true)
            let response = await ApiService.post(`${url}/${state.stationId}`)
            commit(SET_STATION_INFO, response.data)
            commit(SET_KEY)
            commit(SET_LOADING, false)

        } catch (error) {
            commit(SET_LOADING, false)
                //throw error
        }
    },

    [FETCH_STATION_INFO]: async({ commit }, payload) => {

        try {
            if (payload.repeat) { // called by setinterval
                let response = await ApiService.query(`admin/get-station/${payload.id}`)
                commit(SET_STATION_INFO, response.data)
                commit(SELECT_STATION, response.data.station)
                commit(SET_LISTENERS, response.data.listener_info)

            } else {
                commit(SET_LOADING, true)
                let response = await ApiService.query(`admin/get-station/${payload.id}`)
                commit(SET_STATION_INFO, response.data)
                commit(SELECT_STATION, response.data.station)
                commit(SET_LISTENERS, response.data.listener_info)

            }
            commit(SET_LOADING, false)
        } catch (error) {
            commit(SET_LOADING, false)
                // throw error

        }

    },

}

export default {
    state,
    mutations,
    actions
}